/**
 * @author chenlijuan
 * @date 2021-04-26 17:41
 * @description 字典表
 */
//工具
import { isEmpty } from 'lodash-es';
import storage from './sessionStorage';
// api
import { queryDictCodeByCode } from '@/shared/services/common';
/**
 * 获取指定的code字典翻译，本地sessionStorage里面存在，就走本地，不存在就走后端
 * @param code
 */
export const getDictCodeByCode = async (code) => {
    //本地不存在，走后端
    const res = await queryDictCodeByCode(code);
    const { code: resCode, data } = res;
    if (resCode === 200) {
        storage.set(code, data);
        return data;
    }
    else {
        return [];
    }
};
import { useEffect, useState } from 'react';
export const useDictCodeByCodes = (codeArr) => {
    /**
     * 字典
     */
    const [dictCodeObj, setDictCodeObj] = useState({});
    useEffect(() => {
        if (isEmpty(codeArr))
            return;
        const newDictCodeObj = {};
        codeArr.forEach(async (codeItem) => {
            const codeItemDict = await getDictCodeByCode(codeItem);
            newDictCodeObj[codeItem] = codeItemDict;
        });
        console.log({ newDictCodeObj });
        setDictCodeObj(newDictCodeObj);
    }, []);
    return dictCodeObj;
};
